import { __makeTemplateObject } from "tslib";
import styled from "styled-components";
export var HorizontalRule = styled.hr(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  border: none;\n  border-top: ", ";\n  width: ", ";\n  margin: ", ";\n"], ["\n  border: none;\n  border-top: ", ";\n  width: ", ";\n  margin: ", ";\n"])), function (_a) {
    var _b = _a.$thickness, $thickness = _b === void 0 ? "1px" : _b, _c = _a.$style, $style = _c === void 0 ? "solid" : _c, _d = _a.$color, $color = _d === void 0 ? "#ccc" : _d;
    return "".concat($thickness, " ").concat($style, " ").concat($color);
}, function (_a) {
    var _b = _a.$width, $width = _b === void 0 ? "100%" : _b;
    return $width;
}, function (_a) {
    var _b = _a.$margin, $margin = _b === void 0 ? "1rem 0" : _b;
    return $margin;
});
var templateObject_1;
